import axios from "axios";
import config from "../../config";
import { store } from "../../store";

export default class API{

    constructor() {
        let token = store.getState().account.token;

        this.instance = axios.create({
          baseURL: `${config.API_SERVER}`,
          headers: token?{
            Authorization: "Bearer "+ token
          }:{},
        });
        this.instance.interceptors.response.use((response)=>response, (error)=>{
          if(error?.response?.status ===401){
            localStorage.clear();
            window.location = '/';
            return Promise.reject(Error(error?.response?.data?.message));
          }
          if(error?.response?.data?.message){
            return Promise.reject(Error(error?.response?.data?.message));
          }
          return Promise.reject(error);
        })
      }

    // Method to call /me endpoint for token verification
    async verifyToken() {
        try {
            const response = await this.instance.get('/admins/me');
            return response.data.data.admin; // Return admin data from response
        } catch (error) {
            throw error;
        }
    }
}